<template>
  <div>{{result}}</div>
</template>

<script>
export default {
  name: 'SVersionCoin',
  props: {
    showStr: {
      type: String,
      default: ''
    },
    request: {
      type: Function
    }
  },
  inject: {
    $MainWrap: {
      default: null
    }
  },
  computed: {
    requestAPI () {
      // eslint-disable-next-line no-undef
      return this.request ? this.request : $request
    },
    result () {
      try {
        // 匹配 ${xxx} 或 ${xxx.yyy} 形式
        const matches = this.showStr.match(/\$\{([\w.]+)\}/g);
        const mapData = {};
        if (matches) {
          matches.forEach((item) => {
            try {
              const key = item.slice(2, -1); // 例如 homeInfo.coin 或 homeInfo.team_code
              // 支持多层级取值
              const keys = key.split('.');
              let value = this.$MainWrap;
              // 处理多层级属性，优先从 apiData 查找根对象
              if (keys.length > 1 && this.$MainWrap.apiData && this.$MainWrap.apiData[keys[0]]) {
                // 多层级：从 apiData 中获取根对象，然后继续查找子属性
                value = this.$MainWrap.apiData[keys[0]];
                for (let i = 1; i < keys.length; i++) {
                  if (value && Object.prototype.hasOwnProperty.call(value, keys[i])) {
                    value = value[keys[i]];
                  } else {
                    value = undefined;
                    break;
                  }
                }
              } else if (keys.length === 1 && this.$MainWrap.apiData && this.$MainWrap.apiData[keys[0]]) {
                // 单层级：直接从 apiData 获取
                value = this.$MainWrap.apiData[keys[0]];
              } else {
                // 如果 apiData 中没有，则按原来的方式查找
                for (let i = 0; i < keys.length; i++) {
                  if (value && Object.prototype.hasOwnProperty.call(value, keys[i])) {
                    value = value[keys[i]];
                  } else {
                    value = undefined;
                    break;
                  }
                }
              }
              mapData[key] = value;
            } catch (e) {
              mapData[item.slice(2, -1)] = undefined;
            }
          })
        }
        const template = this.showStr;
        return template.replace(/\$\{([\w.]+)\}/g, (match, key) => {
          return mapData[key] !== undefined && mapData[key] !== null ? mapData[key] : '0';
        })
      } catch (e) {
        // 兜底处理，出错时返回'0'
        console.log('e', e)
        return '0';
      }
    }
  },
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>
</style>
